import { motion } from "framer-motion";
import { COMPANY } from "@/data/content";

// Elegant intro loader — logo + full company name reveal.
export const Loader = () => (
  <motion.div
    className="loader-wrap grain"
    initial={{ opacity: 1 }}
    animate={{ opacity: 0 }}
    transition={{ duration: 0.6, delay: 1.0 }}
    style={{ pointerEvents: "none" }}
  >
    <div className="text-center max-w-4xl px-6">
      <motion.img
        src={COMPANY.logo}
        alt="Accurate Logo"
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
        className="mx-auto h-24 md:h-28 w-auto rounded-lg shadow-md mb-6"
        data-testid="loader-logo"
      />
      <div className="mask-line" style={{ overflow: "visible" }}>
        <motion.h1
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.2, 0.8, 0.2, 1] }}
          className="font-display text-2xl md:text-4xl lg:text-5xl leading-[1.15] text-slate-900"
        >
          Accurate <span className="text-[#0055FF]">Automation &amp; Reconditioners</span>
        </motion.h1>
      </div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.3, ease: "easeInOut" }}
        className="mt-5 h-[2px] w-56 mx-auto origin-left"
        style={{ background: "linear-gradient(90deg,#0055FF,transparent)" }}
      />
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.6 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="mt-3 text-[11px] tracking-[0.3em] uppercase text-slate-500"
      >
        Industrial Machinery Retrofitting & Upgradation
      </motion.p>
    </div>
  </motion.div>
);

export default Loader;
